import { BoxedSensorsIcon } from '@jouzen/ecom-components/icons/BoxedSensorsIcon';

import { SlideshowItemIconData } from './_data/SlideshowItemIconData';
import type { CarouselImageContent } from './types';

export interface SlideshowItemIconProps
  extends Pick<CarouselImageContent, 'iconName'> {
  readonly className?: string;
}

const SlideshowItemIcon = ({ className, iconName }: SlideshowItemIconProps) => {
  const Icon = SlideshowItemIconData[iconName ?? 'default'] ?? BoxedSensorsIcon;

  return (
    <Icon
      className={className}
      data-cy={`slideshow-item-icon-${iconName}`}
      key={'iconName'}
    />
  );
};

export default SlideshowItemIcon;
